import { nanoid } from "nanoid"

const mapCamposPersonalizados = (camposPersonalizados = [], withId = false) =>
  camposPersonalizados.map(({ clave, valor }) => ({
    clave,
    valor,
    ...(withId && { id: nanoid() }),
  }))

export default mapCamposPersonalizados
